import React from 'react';
import { observer } from 'mobx-react';
import { SellerListTemplate } from 'themes/modules/seller/pages';
import { setCurrentView } from 'core/utils';
import { SellerListViewStore } from 'modules/seller/stores';

@setCurrentView(rootStore => new SellerListViewStore(rootStore), 'sellerListViewStore')
class SellerList extends React.Component {
	constructor(props) {
		super(props);
		const { sellerListViewStore } = this.props;
		sellerListViewStore.setSearchVisible();
		this.permissions = sellerListViewStore.permissions;
	}

	render() {
		return (
			<SellerListTemplate
				{...this.props}
				headerCell={[]}
				actions={this.props.sellerListViewStore}
				viewStore={this.props.sellerListViewStore}
			/>
		);
	}
}

export default SellerList;
